import { useIntl } from "react-intl";
import React, { useState } from "react";
import ReactGA from "react-ga4";
import * as ReactDOM from "react-dom";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import {
  Icon,
  Banner,
  Content,
  Button,
  ReadyToStart,
  Column,
  InformationGroup,
  InformationGroupItem,
  Layout,
  List,
  ItemList,
  Tips,
  Tarifas,
} from "../../components";
import "./Returns.scss";
import useAppContext from "../../context/Context";
import cl from "../../banks/returns_CL.json";
import mx from "../../banks/returns_MX.json";
import Modal from "../../components/Modal/Modal";

const color = "#5C2A48";
gsap.registerPlugin(ScrollTrigger);

export const Returns = () => {
  ReactGA.send({ hitType: "pageview", page: "/returns" });

  const intl = useIntl();
  const { getImages, activeCountry, setStep } = useAppContext();
  const [bankList, setBankList] = React.useState(null);

  React.useEffect(() => {
    setStep && setStep(1);
  }, []);

  const handleChangeBank = () => {
    activeCountry === "cl" ? setBankList(cl) : setBankList(mx);
  };

  React.useEffect(handleChangeBank, [activeCountry]);

  const [openModal, setOpenModal] = useState(false);

  const changeModal = () => {
    setOpenModal(!openModal);
  };

  React.useEffect(() => {
    const w = window.innerWidth;
    const c1Center = "-150px";
    const c2Center = "165";
    const c3Center = "445";
    const tlData = gsap
      .timeline({
        scrollTrigger: {
          trigger: ".section2",
          start: w > 1200 ? "top 20%" : "top top",
          end: "95% 40%",
          scrub: 1,
          pin: ".animation-container",
        },
      })
      .to(".circle-1", {
        transform: `translate(${c1Center}, 150px)`,
      })
      .to(".circle-1", {
        transform: `translate(${c1Center}, 50px)`,
      })
      .to(".circle-1", {
        transform: `translate(${c1Center}, 245px)`,
        borderRadius: "0",
        height: "32px",
      })
      .to(".circle-1", {
        zIndex: "3",
        transform: `translate(${c1Center}, 245px)`,
      })
      .to(".circle-2", {
        transform: `translate(${c2Center}px,-150px)`,
      })
      .to(".circle-2", {
        width: "200px",
        height: "200px",
        transform: `translate(${c2Center - 25}px,-90px)`,
      })
      .to(".circle-2", {
        transform: `translate(${c2Center - 25}px, 0px)`,
        borderRadius: "0",
        height: "32px",
      })
      .to(".circle-2", {
        zIndex: "2",
        transform: `translate(${c2Center - 25}px, 25px)`,
      })
      .to(".circle-3", {
        transform: `translate(${c3Center}px,-400px)`,
      })
      .to(".circle-3", {
        width: "90px",
        height: "90px",
        transform: `translate(${c3Center - 10}px,-235px)`,
      })
      .to(".circle-3", {
        transform: `translate(${c3Center - 10}px,-245px)`,
        borderRadius: "0",
        height: "32px",
      })
      .to(".circle-3", {
        zIndex: "1",
        transform: `translate(${c3Center - 10}px,-190px)`,
      });
    return () => {
      tlData.kill();
      // anim.scrollTrigger.kill();
    };
  }, []);
  const content = (
    <Layout title="Devoluciones">
      {openModal === true &&
        ReactDOM.createPortal(
          <Modal
            changeModal={changeModal}
            content={
              <iframe
                title="Formulario de contacto"
                className="iframe"
                src={
                  activeCountry === "mx"
                    ? "https://share.hsforms.com/14Hl-W1oeQx-uUbcs4v0x5A5l986"
                    : "https://share.hsforms.com/1nESwD7ncTxK4ewZnR1u7yQ5l986"
                }
                frameborder="0"
              ></iframe>
            }
          ></Modal>,
          document.getElementById("portal")
        )}

      <Banner
        customClass="banner-quick"
        background={getImages["banner_background_returns"]}
      >
        <Content
          content={
            <div className="banner-top-icon">
              <div>
                <Icon name="Returns" />
              </div>
              <p>Devoluciones</p>
            </div>
          }
          title={intl.formatMessage({ id: "banner.returns.title" })}
          subtitle={intl.formatMessage({ id: "banner.returns.subtitle" })}
          footer={
            <>
              <a href="https://dashboard.etpay.com/sign-up">
                <Button bgColor={color} bgHoverColor="#140F33" color="#fff">
                  <Icon name={"Icon_Pre"} fill="#fff" />
                  <span>
                    {intl.formatMessage({ id: "button.testFree.text" })}
                  </span>
                </Button>
              </a>
              <p>
                o llámanos al{" "}
                {activeCountry === "mx"
                  ? "+52 55 4169 7254"
                  : "+56 2 3210 1557"}
              </p>

              {/* <a href={
                'tel:' + intl.formatMessage({ id: "banner.home.button2.url" })
              }>
                <Button bgColor={"#F2F2F2"} bgHoverColor="#140F33">
                  <span>
                    {intl.formatMessage({ id: "banner.home.button2.text" }) + intl.formatMessage({ id: "banner.home.button2.url" })}
                  </span>
                  <Icon name="icon-phone"></Icon>
                </Button>
              </a> */}
            </>
          }
          customClass="grid-5"
        />
        <div
          className="image-banner"
          style={{
            gridColumn: "7 / 13",
            marginTop: 0,
          }}
        >
          <img src={getImages["banner_image_returns"]} alt="" />
        </div>
      </Banner>

      <div className="returns-page">
        <Tips
          tip1={intl.formatMessage({ id: "returns.section1.t1" })}
          tip2={intl.formatMessage({ id: "returns.section1.t2" })}
          tip3={intl.formatMessage({ id: "returns.section1.t3" })}
        ></Tips>
        <Column customClass="section2">
          <div className="list">
            <div className="part">
              <h3 className="top-title red">
                {intl.formatMessage({ id: "returns.section2.t1" })}
              </h3>
              <h2 className="title">
                {intl.formatMessage({ id: "returns.section2.t2" })}
              </h2>
              <h4 className="sub-title">
                {intl.formatMessage({ id: "returns.section2.t3" })}
              </h4>
            </div>

            <div className="part">
              <h3 className="top-title">
                {intl.formatMessage({ id: "returns.section2.t4" })}
              </h3>
              <h4 className="sub-title">
                {intl.formatMessage({ id: "returns.section2.t5" })}
              </h4>
            </div>

            <div className="part">
              <h3 className="top-title">
                {intl.formatMessage({ id: "returns.section2.t6" })}
              </h3>
              <h4 className="sub-title">
                {intl.formatMessage({ id: "returns.section2.t7" })}
              </h4>

              <List>
                {bankList &&
                  Object.keys(bankList).map(
                    (bank, i) =>
                      !bank.includes("unchecked") && (
                        <ItemList key={bankList[bank]["name"] + i}>
                          <Icon name={bankList[bank]["icon"]} size="24px" />
                          <p>{bankList[bank]["name"]}</p>
                          {bankList[bank]["new"] === "true" && (
                            <label>Proximamente</label>
                          )}
                        </ItemList>
                      )
                  )}
              </List>
            </div>

            <div className="part">
              <h3 className="top-title">
                {intl.formatMessage({ id: "returns.section2.t8" })}
              </h3>
              <h4 className="sub-title">
                {intl.formatMessage({ id: "returns.section2.t9" })}
              </h4>
            </div>

            <div className="part">
              <h3 className="top-title">
                {intl.formatMessage({ id: "returns.section2.t10" })}
              </h3>
              <h4 className="sub-title">
                {intl.formatMessage({ id: "returns.section2.t11" })}
              </h4>
            </div>
          </div>
          {/* desktop */}
          <div className="animation-container">
            <div className="circle circle-1"></div>

            <div className="circle circle-white circle-white-1"></div>

            <div className="circle circle-2"></div>

            <div className="circle circle-white circle-white-2"></div>

            <div className="circle circle-3"></div>

            <div className="circle circle-white circle-white-3"></div>
          </div>
        </Column>
        <InformationGroup
          color={color}
          topTitle={intl.formatMessage({
            id: "returns.informationGroup.topTitle",
          })}
          title={intl.formatMessage({ id: "returns.informationGroup.title" })}
          description={intl.formatMessage({
            id: "returns.informationGroup.description",
          })}
        >
          <InformationGroupItem
            icon="Exclude"
            description={intl.formatMessage({
              id: "returns.informationGroup.item1.description",
            })}
            color={color}
          ></InformationGroupItem>
          <InformationGroupItem
            icon="ReadWrite"
            description={intl.formatMessage({
              id: "returns.informationGroup.item2.description",
            })}
            color={color}
          ></InformationGroupItem>
          <InformationGroupItem
            icon="Bank"
            description={intl.formatMessage({
              id: "returns.informationGroup.item3.description",
            })}
            color={color}
          ></InformationGroupItem>
        </InformationGroup>
        {/* <PosibleWidthEtpay color={color}></PosibleWidthEtpay> */}
        <Tarifas />
        <ReadyToStart />
      </div>
    </Layout>
  );

  return content;
};
